import React, { useContext } from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import Search from "../../../components/searchField";
import { Context } from "../Provider";

const HeaderView = () => {
    const context = useContext(Context);

    return(
        <>
            <div className="row">
                <div className="col-lg-6 col-7">
                    <h6 className="text-uppercase text-white text-capitalize ps-3">
                        TRADESPERSONS RATINGS
                    </h6>
                </div>
                <div className="col-lg-6 col-5 my-auto text-end">
                    <div className="row">
                        <div className="col-md-10">
                            <Search
                                onSearch = {(search_text) => {
                                    context.dispatch({ type: "SET_SERACH_TEXT", serach_text: search_text });
                                }}
                            />
                        </div>
                        <div className="col-md-2">
                            <div className="dropdown  pe-4">
                                <a
                                    className="text-white cursor-pointer"
                                    onClick={() => context.dispatch({
                                        type: 'IS_SHOW_DATE_FILTER',
                                        is_show_date_filter: true
                                    })}
                                >
                                    <CalendarMonthIcon />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HeaderView;